export default __webpack_public_path__ + "static/media/compartilhar.e5edbb7a.svg";